import React, { Component } from 'react'
import PropTypes from 'prop-types'
import withAuthorizer from './with-authorizer'
import withWorkspace from './with-workspace'
import UtilService from '../../services/util'
import { navPolicyMap } from '../../services/access-policy'

export default function withCanI(ChildComponent) {
    class withCanIWrapper extends Component {
        static propTypes = {
            authorizer: PropTypes.object,
            workspace: PropTypes.object
        }

        constructor(props) {
            super(props)

            this.canI = this.canI.bind(this)
        }

        createPolicy(policy) {
            if (Array.isArray(policy)) {
                const isArrayOfString = policy.every(action => typeof action === 'string')

                if (!isArrayOfString) {
                    UtilService.safeLog('Invalid policy action. Expecting array of string.')
                    return null
                }

                return {
                    action: policy
                }
            }

            switch (typeof policy) {
                case 'string':
                    return { action: [policy] }
                case 'object':
                    return policy
                default:
                    return null
            }
        }

        canI(policy, workspace = null) {
            const { authorizer, workspace: currentWorkspace } = this.props

            workspace = workspace || currentWorkspace

            policy = this.createPolicy(policy)

            return authorizer.allowNav(policy, workspace)
        }

        render() {
            const props = {
                canI: this.canI,
                navPolicyMap
            }

            return (
                <ChildComponent
                    {...props}
                    {...this.props}
                />
            )
        }
    }

    return withAuthorizer(withWorkspace(withCanIWrapper))
}


// WEBPACK FOOTER //
// src/containers/high-order-components/with-can-i.js